import React from 'react';
import LegalLayout from '../components/LegalLayout';
import { useTranslation } from 'react-i18next';

const TermsOfService: React.FC = () => {
  const { t } = useTranslation();
  return (
    <LegalLayout title={t('legalPages.terms.title')} lastUpdated={t('legalPages.lastUpdatedDate')}>
      <div className="space-y-8">
        <section>
          <h2 className="text-2xl font-bold text-gray-900 mb-4">{t('legalPages.terms.acceptance.title')}</h2>
          <p className="text-gray-700 mb-4">
            {t('legalPages.terms.acceptance.p1')}
          </p>
          <p className="text-gray-700">
            {t('legalPages.terms.acceptance.p2')}
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-bold text-gray-900 mb-4">{t('legalPages.terms.serviceDesc.title')}</h2>
          <p className="text-gray-700 mb-4">
            {t('legalPages.terms.serviceDesc.p')}
          </p>
          <ul className="list-disc list-inside text-gray-700 space-y-2">
            <li>{t('legalPages.terms.serviceDesc.items.0')}</li>
            <li>{t('legalPages.terms.serviceDesc.items.1')}</li>
            <li>{t('legalPages.terms.serviceDesc.items.2')}</li>
            <li>{t('legalPages.terms.serviceDesc.items.3')}</li>
            <li>{t('legalPages.terms.serviceDesc.items.4')}</li>
            <li>{t('legalPages.terms.serviceDesc.items.5')}</li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-bold text-gray-900 mb-4">{t('legalPages.terms.account.title')}</h2>
          <h3 className="text-xl font-semibold text-gray-800 mb-3">{t('legalPages.terms.account.create.title')}</h3>
          <p className="text-gray-700 mb-4">
            {t('legalPages.terms.account.create.p')}
          </p>

          <h3 className="text-xl font-semibold text-gray-800 mb-3">{t('legalPages.terms.account.responsibility.title')}</h3>
          <p className="text-gray-700">
            {t('legalPages.terms.account.responsibility.p')}
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-bold text-gray-900 mb-4">{t('legalPages.terms.acceptableUse.title')}</h2>
          <h3 className="text-xl font-semibold text-gray-800 mb-3">{t('legalPages.terms.acceptableUse.allowed.title')}</h3>
          <p className="text-gray-700 mb-4">
            {t('legalPages.terms.acceptableUse.allowed.p')}
          </p>

          <h3 className="text-xl font-semibold text-gray-800 mb-3">{t('legalPages.terms.acceptableUse.prohibited.title')}</h3>
          <p className="text-gray-700 mb-4">{t('legalPages.terms.acceptableUse.prohibited.p')}</p>
          <ul className="list-disc list-inside text-gray-700 space-y-2">
            <li>{t('legalPages.terms.acceptableUse.prohibited.items.0')}</li>
            <li>{t('legalPages.terms.acceptableUse.prohibited.items.1')}</li>
            <li>{t('legalPages.terms.acceptableUse.prohibited.items.2')}</li>
            <li>{t('legalPages.terms.acceptableUse.prohibited.items.3')}</li>
            <li>{t('legalPages.terms.acceptableUse.prohibited.items.4')}</li>
            <li>{t('legalPages.terms.acceptableUse.prohibited.items.5')}</li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-bold text-gray-900 mb-4">{t('legalPages.terms.billing.title')}</h2>
          <h3 className="text-xl font-semibold text-gray-800 mb-3">{t('legalPages.terms.billing.fees.title')}</h3>
          <p className="text-gray-700 mb-4">
            {t('legalPages.terms.billing.fees.p')}
          </p>

          <h3 className="text-xl font-semibold text-gray-800 mb-3">{t('legalPages.terms.billing.auto.title')}</h3>
          <p className="text-gray-700">
            {t('legalPages.terms.billing.auto.p')}
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-bold text-gray-900 mb-4">{t('legalPages.terms.ip.title')}</h2>
          <h3 className="text-xl font-semibold text-gray-800 mb-3">{t('legalPages.terms.ip.ownership.title')}</h3>
          <p className="text-gray-700 mb-4">
            {t('legalPages.terms.ip.ownership.p')}
          </p>

          <h3 className="text-xl font-semibold text-gray-800 mb-3">{t('legalPages.terms.ip.clientContent.title')}</h3>
          <p className="text-gray-700">
            {t('legalPages.terms.ip.clientContent.p')}
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-bold text-gray-900 mb-4">{t('legalPages.terms.suspension.title')}</h2>
          <p className="text-gray-700 mb-4">
            {t('legalPages.terms.suspension.p')}
          </p>
          <ul className="list-disc list-inside text-gray-700 space-y-2">
            <li>{t('legalPages.terms.suspension.items.0')}</li>
            <li>{t('legalPages.terms.suspension.items.1')}</li>
            <li>{t('legalPages.terms.suspension.items.2')}</li>
            <li>{t('legalPages.terms.suspension.items.3')}</li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-bold text-gray-900 mb-4">{t('legalPages.terms.liability.title')}</h2>
          <p className="text-gray-700 mb-4">
            {t('legalPages.terms.liability.p1')}
          </p>
          <p className="text-gray-700">
            {t('legalPages.terms.liability.p2')}
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-bold text-gray-900 mb-4">{t('legalPages.terms.changes.title')}</h2>
          <p className="text-gray-700">
            {t('legalPages.terms.changes.p')}
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-bold text-gray-900 mb-4">{t('legalPages.terms.law.title')}</h2>
          <p className="text-gray-700">
            {t('legalPages.terms.law.p')}
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-bold text-gray-900 mb-4">{t('legalPages.contact.title')}</h2>
          <p className="text-gray-700 mb-4">
            {t('legalPages.contact.p')}
          </p>
          <div className="bg-gray-100 p-4 rounded-lg">
            <p className="text-gray-700"><strong>{t('legalPages.contact.email')}</strong> legal@tapeat.com</p>
            <p className="text-gray-700"><strong>{t('legalPages.contact.phone')}</strong> +351 968 682 315</p>
            <p className="text-gray-700"><strong>{t('legalPages.contact.address')}</strong> Açores, Portugal</p>
          </div>
        </section>
      </div>
    </LegalLayout>
  );
};

export default TermsOfService;